import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { NoResults, TableWrapper } from '@components';
import { Children, PropsWithChildren } from 'react';
import { useFlagFixed } from '@hooks';
import { Flag } from '@utils';

function TableHeader() {
  const { isEnabled: isRiskScoreEnabled } = useFlagFixed(Flag.SHOW_RISK_SCORE);

  return (
    <TableHead>
      <TableRow>
        <TableCell>Resources</TableCell>
        <TableCell>Entitlements</TableCell>
        {isRiskScoreEnabled && <TableCell>Risk Scores</TableCell>}
        <TableCell>Integration</TableCell>
        <TableCell>Resource Type</TableCell>
      </TableRow>
    </TableHead>
  );
}

export function InventoryTable({ children, isLoading }: PropsWithChildren<{ isLoading: boolean }>) {
  if (Children.count(children) === 0) {
    return <NoResults>No resources found</NoResults>;
  }

  return (
    <TableWrapper loading={isLoading}>
      <Table>
        <TableHeader />
        <TableBody>{children}</TableBody>
      </Table>
    </TableWrapper>
  );
}
